import React, {useState} from 'react';
import Modal from 'react-modal';

const BfFormstep23 = ({lang, setLang, nextStep, backStep, backStepby2, formData, setDriverCount, driverCount, setFormData, setDriverIndexToEdit, setDriverIndexToDisplay}) => {  
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [driverToDelete, setDriverToDelete] = useState(null);

  const handleEdit = (index, display) => {
      setDriverIndexToEdit(index);
      setDriverIndexToDisplay(display);
    backStep();
}
  const decrementDriverCount = () => {
    setDriverCount(driverCount - 1);
  }
  const handleDelete = (driverIndexToDelete) => {
    const newFormData = Object.keys(formData.step22).reduce((acc, key) => {
      if (!key.includes(`drivers[${driverIndexToDelete}]`)) {
        acc[key] = formData.step22[key];
      }
      return acc;
    }, {});
  
    setFormData({ ...formData, step22: newFormData });
    decrementDriverCount();
  };


  const openModal = (driverIndex) => {
    setDriverToDelete(driverIndex);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setDriverToDelete(null);
    setModalIsOpen(false);
  };

  const confirmDelete = () => {
    handleDelete(driverToDelete);
    closeModal();
  };

  return (
    
<>
<>
  <header className="c-site-header">
    <a className="c-site-header__skip js-site-header-skip" href="#main">
      Skip to main content
    </a>
    <div className="o-wrapper">
      <a
        className="c-site-header__logo-link"
        href="./"
        aria-label="Go to home page"
      >
        <img
          className="c-site-header__logo"
          src="images/components/site-header/logo-blf-specialty.svg"
          alt="Bluefire Specialty Logo"
          width={100}
          height={34}
        />
      </a>
      <h1 className="c-site-header__title">
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-drivers" />
            </svg>
          </span>
          {lang === 'eng' ? 'Drivers Information' : 'Información de conductores'}

        </h1>
      <div className="c-site-header__controls c-header-controls">
      <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
      </div>
    </div>
  </header>
  <main className="c-main-content">
    <div className="c-section">
      <div className="o-wrapper o-wrapper--small">
        <h1 className="c-section__title">
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-drivers" />
            </svg>
          </span>
          {lang === 'eng' ? 'Drivers Information' : 'Información de conductores'}
        </h1>
        <div className="c-section__content">
          <div className="c-steps">
            <ul className="o-list-bare c-steps__list">
              <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item c-steps__item--90 c-steps__step--active">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>                  <div className="c-steps__circle" />
                 
                </div>
              </li>
            </ul>
          </div>
          <div className="c-content c-content--large">
            <div className="c-simple-table ">
              <div className="c-simple-table__controls">
                <button
                  className="c-button c-button--small c-button--linear-indingo"
                  onClick={backStepby2}
                >
                  {lang === 'eng' ? 'Previous' : 'Atrás'}
                </button>
                <button
                  className="c-button--small c-button c-button--blue-linear"
                  type="button"
                  onClick={backStep}
                >
                  <span className="o-icon">
                    <svg aria-hidden="true" focusable="false" role="img">
                      <use href="images/icons/icons.svg#icon-plus" />
                    </svg>
                  </span>
                  {lang === 'eng' ? 'Add another driver' : 'Agregar otro conductor'}
                </button>
                <button
                  className="c-button--small c-button c-button--blue"
                  type="button"
                  onClick={nextStep}
                >
                  {lang === 'eng' ? 'Save and Continue' : 'Guardar y continuar'}
                </button>
              </div>
              <div className="c-simple-table__indicator">
                {lang === 'eng' ? 'Scroll for more' : 'Desliza para más'}
                <span className="o-icon">
                <svg width="15" height="15" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="1060738_gesture_hand_swipe_swipe left_touch_icon 1">
  <g id="Group 625404">
  <path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M14.8015 3.35983C14.2027 3.35983 13.7173 3.84498 13.7173 4.44358V16.6517C13.7173 16.8929 13.5614 17.1065 13.3315 17.1801C13.1017 17.2538 12.8507 17.1706 12.7104 16.9743L12.7091 16.9724L12.7038 16.9652L12.6818 16.9348C12.6622 16.9079 12.6327 16.8677 12.5944 16.8163C12.5177 16.7134 12.4056 16.5655 12.2658 16.3876C11.9856 16.0311 11.5967 15.5581 11.1592 15.0871C10.7191 14.6134 10.2428 14.1559 9.78799 13.821C9.3113 13.4699 8.94909 13.3222 8.72071 13.3222C8.36928 13.3222 8.09736 13.4275 7.91908 13.5917C7.74827 13.7489 7.61035 14.0084 7.61035 14.432C7.61035 14.5207 7.65405 14.6749 7.88687 14.9798C8.08604 15.2406 8.36527 15.5404 8.73685 15.9393C8.79537 16.0021 8.85619 16.0674 8.91934 16.1354C9.83259 17.1184 11.1081 18.5349 12.5226 20.7969C12.5458 20.8341 12.5646 20.8739 12.5784 20.9155C12.8379 21.6937 13.4965 23.1418 14.6755 24.3857C15.8443 25.6189 17.5107 26.6402 19.8242 26.6402C21.5796 26.6402 23.11 25.7923 24.2103 24.5809C25.3179 23.3617 25.9415 21.8268 25.9312 20.5406L25.9312 20.5361V13.2961C25.9312 12.6975 25.4458 12.2124 24.8469 12.2124H24.7947C24.1958 12.2124 23.7105 12.6975 23.7105 13.2961V14.987C23.7105 15.2934 23.4619 15.5419 23.1553 15.5419C22.8487 15.5419 22.6001 15.2934 22.6001 14.987V12.1863C22.6001 11.5877 22.1147 11.1026 21.5159 11.1026H21.4637C20.8648 11.1026 20.3794 11.5877 20.3794 12.1863V14.987C20.3794 15.2934 20.1308 15.5419 19.8242 15.5419C19.5176 15.5419 19.2691 15.2934 19.2691 14.987V11.6314C19.2691 11.0328 18.7837 10.5476 18.1848 10.5476H18.1326C17.5337 10.5476 17.0483 11.0328 17.0483 11.6314V14.987C17.0483 15.2934 16.7998 15.5419 16.4932 15.5419C16.1866 15.5419 15.938 15.2934 15.938 14.987V4.44358C15.938 3.84511 15.4522 3.35983 14.8537 3.35983H14.8015ZM17.0483 9.72376V4.44358C17.0483 3.23192 16.0652 2.25 14.8537 2.25H14.8015C13.5894 2.25 12.6069 3.23204 12.6069 4.44358V15.049C12.4136 14.8201 12.1998 14.5763 11.9728 14.3319C11.5107 13.8345 10.9808 13.3209 10.4467 12.9275C9.93443 12.5503 9.32509 12.2124 8.72071 12.2124C8.1522 12.2124 7.59136 12.3845 7.16686 12.7753C6.73488 13.173 6.5 13.7459 6.5 14.432C6.5 14.8983 6.73389 15.2991 7.0042 15.6531C7.23927 15.961 7.5623 16.3075 7.92769 16.6994C7.986 16.762 8.0454 16.8257 8.10568 16.8906C8.9893 17.8417 10.1991 19.1851 11.5468 21.3305C11.8556 22.2288 12.5813 23.7899 13.8694 25.149C15.1989 26.5516 17.1411 27.75 19.8242 27.75C21.955 27.75 23.7675 26.7195 25.0324 25.3269C26.2896 23.9429 27.0538 22.1493 27.0415 20.5338V13.2961C27.0415 12.0846 26.059 11.1026 24.8469 11.1026H24.7947C24.3491 11.1026 23.9346 11.2353 23.5885 11.4633C23.2895 10.607 22.4745 9.99273 21.5159 9.99273H21.4637C20.9315 9.99273 20.4435 10.1821 20.0636 10.497C19.6791 9.86212 18.9815 9.43781 18.1848 9.43781H18.1326C17.7382 9.43781 17.3682 9.54177 17.0483 9.72376Z" fill="#383838"/>
  <g id="Group 625402">
  <path id="Vector (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M3 5.57913C3 5.27297 3.24819 5.02478 3.55435 5.02478H10.2065C10.5127 5.02478 10.7609 5.27297 10.7609 5.57913C10.7609 5.88529 10.5127 6.13348 10.2065 6.13348H3.55435C3.24819 6.13348 3 5.88529 3 5.57913Z" fill="#383838"/>
  <path id="Vector (Stroke)_3" fill-rule="evenodd" clip-rule="evenodd" d="M7.30631 2.45265C7.50231 2.68785 7.47053 3.0374 7.23533 3.2334L3.90925 6.00514C3.67405 6.20113 3.3245 6.16936 3.1285 5.93416C2.9325 5.69896 2.96428 5.34941 3.19948 5.15341L6.52556 2.38167C6.76076 2.18568 7.11031 2.21745 7.30631 2.45265Z" fill="#383838"/>
  <path id="Vector (Stroke)_4" fill-rule="evenodd" clip-rule="evenodd" d="M3.1285 5.22426C3.3245 4.98906 3.67405 4.95728 3.90925 5.15328L7.23533 7.92502C7.47053 8.12102 7.50231 8.47057 7.30631 8.70577C7.11031 8.94096 6.76076 8.97274 6.52556 8.77674L3.19948 6.005C2.96428 5.80901 2.9325 5.45945 3.1285 5.22426Z" fill="#383838"/>
  </g>
  <g id="Group 625403">
  <path id="Vector (Stroke)_5" fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.57901C26.25 5.27285 26.0018 5.02466 25.6957 5.02466H19.0435C18.7373 5.02466 18.4891 5.27285 18.4891 5.57901C18.4891 5.88516 18.7373 6.13335 19.0435 6.13335H25.6957C26.0018 6.13335 26.25 5.88516 26.25 5.57901Z" fill="#383838"/>
  <path id="Vector (Stroke)_6" fill-rule="evenodd" clip-rule="evenodd" d="M21.9437 2.45241C21.7477 2.6876 21.7795 3.03716 22.0147 3.23315L25.3408 6.00489C25.576 6.20089 25.9255 6.16911 26.1215 5.93391C26.3175 5.69872 26.2857 5.34917 26.0505 5.15317L22.7244 2.38143C22.4892 2.18543 22.1397 2.21721 21.9437 2.45241Z" fill="#383838"/>
  <path id="Vector (Stroke)_7" fill-rule="evenodd" clip-rule="evenodd" d="M26.1215 5.22414C25.9255 4.98894 25.576 4.95716 25.3408 5.15316L22.0147 7.9249C21.7795 8.12089 21.7477 8.47045 21.9437 8.70564C22.1397 8.94084 22.4892 8.97262 22.7244 8.77662L26.0505 6.00488C26.2857 5.80888 26.3175 5.45933 26.1215 5.22414Z" fill="#383838"/>
  </g>
  </g>
  </g>
  </svg>
  
                </span>
              </div>
              <div className="c-simple-table__content">
              <table className="c-simple-table__table">
             
              <tbody>
  <tr>
    <th>
    {lang === 'eng' ? 'N°' : 'N°'}
    </th>
    <th>
    {lang === 'eng' ? 'Driver Name' : 'Nombre del conductor'}
    </th>
    <th>
    {lang === 'eng' ? 'Lic. No.' : 'No. Lic.'}
    </th>
    <th>
    {lang === 'eng' ? 'Issued State Mx' : 'Estado de emisión Mx'}
    </th>
    <th>
    {lang === 'eng' ? 'Expiration Date' : 'Fecha de vencimiento'}
    </th>
    <th>
    {lang === 'eng' ? 'Edit' : 'Editar'}
    </th>
    <th>
    {lang === 'eng' ? 'Remove' : 'Eliminar'}
        </th>
  </tr>
  {Array.from(new Set(Object.keys(formData.step22)
    .filter(key => key.includes("first name"))
    .map(key => parseInt(key.match(/\d+/)[0])))) // extract the driver index as integer
    .sort((a, b) => b - a) // sort in descending order
    .map((driverIndex, displayIndex, array) => (
    <tr key={driverIndex}>
      <td>
        <strong>{array.length - displayIndex}</strong>
      </td>
      <td>
        <span className="o-icon c-simple-table__icon-driver">
          <svg aria-hidden="true" focusable="false" role="img">
            <use href="images/icons/icons.svg#icon-person-driving" />
          </svg>
        </span>
        <strong>
          {`${formData.step22[`drivers[${driverIndex}]first name`] || ""} 
          ${formData.step22[`drivers[${driverIndex}]last name`] || ""}`}
        </strong>
      </td>
      <td>{formData.step22[`drivers[${driverIndex}]license no`] || ""}</td>
      <td>{formData.step22[`drivers[${driverIndex}]issued state mx`] || ""}</td>
      <td>{formData.step22[`drivers[${driverIndex}]expiration date`] || ""}</td>
      <td>
      <button className="c-simple-table__btn-edit" type="button" onClick={() => handleEdit(driverIndex, (array.length - displayIndex))}>
    <span className="o-icon">
    <svg aria-hidden="true" focusable="false" role="img">
    <use href="#icon-edit" />
    <symbol id="icon-edit" viewBox="0 0 20 20">
        <g clip-path="url(#a)">
            <path d="M18.46 12.564a.498.498 0 0 0-.499.498v4.423a1.496 1.496 0 0 1-1.494 1.494H2.49c-.825 0-1.494-.67-1.495-1.494V4.505A1.496 1.496 0 0 1 2.491 3.01h4.422a.498.498 0 1 0 0-.996H2.491A2.493 2.493 0 0 0 0 4.504v12.98a2.493 2.493 0 0 0 2.49 2.491h13.977a2.493 2.493 0 0 0 2.49-2.49v-4.423a.498.498 0 0 0-.498-.498Z"/>
            <path d="M18.76.732a2.241 2.241 0 0 0-3.17 0L6.704 9.62a.498.498 0 0 0-.128.22l-1.169 4.218a.498.498 0 0 0 .613.613l4.22-1.169a.497.497 0 0 0 .218-.127l8.887-8.887a2.244 2.244 0 0 0 0-3.17L18.76.732ZM7.79 9.942l7.272-7.272 2.346 2.345-7.274 7.273L7.79 9.943Zm-.47.94 1.874 1.875-2.592.718.719-2.592Zm11.32-7.1-.528.529-2.346-2.346.529-.528a1.245 1.245 0 0 1 1.76 0l.585.584a1.247 1.247 0 0 1 0 1.761Z"/>
        </g>
    </symbol>
</svg>

    </span>
</button>
      </td>
      <td>
        <button 
          className="c-simple-table__btn-delete" 
          type="button"
          onClick={() => openModal(driverIndex)}>
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-delete" />
            </svg>
          </span>
        </button>
      </td>
    </tr>
  ))}
</tbody>
   {/* Modal for confirmation */}
   <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
          },
            overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Darken the background
    },
        }}
      >
        <div>
          <p>{lang === 'eng'? "Are you sure you want to delete this driver?": "¿Está seguro que quiere eliminar este conductor?"}</p>
          <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '20px' }}>
   
          <button  className="c-button c-button--small c-button--linear-indingo" onClick={confirmDelete}>{lang === 'eng' ? "Yes" : "Si"}</button>
          <button className="c-button c-button--small c-button--linear-indingo"  onClick={closeModal}>No</button>
          </div>
        </div>
      </Modal>
    </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
</>

</>
  );}

  export default BfFormstep23;